import SchoolCardContainer from '../components/home/SchoolCardContainer'
import { Stock, Grade } from '../components'
import { AddBatch } from '../components/addbatch'
import { Update } from '../components/update'
import EmptyCardContainer from '../components/home/EmptyCardContainer'
import { useBatchStore } from '../store/batch/useBatchStore'
import { useActiveRelationStore } from '../store/activeRelation/useActiveRelationStore'
import { UndoButton } from '../components/home/Undo'

export default function Home() {
  const storedBatchList = useBatchStore((state) => state.batches)
  const storedARList = useActiveRelationStore((state) => state.activeRelations)

  const createBatchBlocks = Object.keys(storedBatchList)
    .sort((batchIdBefore, batchIdAfter) => {
      if (storedBatchList[batchIdBefore].startDate < storedBatchList[batchIdAfter].startDate)
        return 1
      else return -1
    })
    .map((batchId) => {
      if (storedARList[batchId] === undefined || storedARList[batchId].length === 0) {
        return null
      }
      return batchId === '$empty' ? null : <SchoolCardContainer key={batchId} batchId={batchId} />
    })
  return (
    <div className="p-[40px]">
      <div className="flex justify-between">
        <div>
          <h1 className="font-bold text-tdplindigo text-[2rem]">Home</h1>
          {/*<h1 className="text-tdplindigo ml-4 text-[2rem]">Home</h1>*/}
        </div>
        <div className="flex justify-evenly">
          <Update />
          <Grade />
          <AddBatch />
          <Stock />
          <UndoButton />
        </div>
      </div>
      <div>{createBatchBlocks}</div>
      <div>
        <EmptyCardContainer />
      </div>
    </div>
  )
}
